'use strict';

import {
  f7
} from "framework7-svelte";
import { getSecuredFirestore } from "./Firestore.js";
import { format } from "./i18n.js";

const NEW_LINE = "\n";
const COMPACT = ", ";
const HTML = "<br>";

function formatAddress(options) {
  let linebreak = options.mode || NEW_LINE;
  return (options.building ? options.building + linebreak : "") +
    (options.moo ? options.moo + linebreak : "") +
    (options.street ? options.street + ", " : "") +
    (options.subdistrict ? options.subdistrict + linebreak : "") +
    (options.district ? options.district + ", " + options.province + linebreak : "") +
    (options.zipcode ? options.zipcode + linebreak : "") +
    options.country;
}

function setPrimaryAddress(userId, addressId) {
  return getSecuredFirestore().then(function (firestore) {
    let writeBatch = firestore.batch();

    let messageDoc = firestore.doc(
      "users/" + userId + "/addresses/" + addressId
    );
    writeBatch.update(messageDoc, { primary: true });

    return messageDoc.parent
      .get()
      .then(function (snapshot) {
        let docs = snapshot.docs;
        for (let index = 0; index < docs.length; index++) {
          const doc = docs[index];

          if (doc.id !== addressId && doc.get("primary") === true) {
            writeBatch.update(doc.ref, { primary: false });
          }
        }
      })
      .then(function () {
        writeBatch.commit();
      });
  });
}

function deleteAddress(userId, addressId, primary) {
  return getSecuredFirestore().then(function (firestore) {
    let writeBatch = firestore.batch();
    let addressDoc = firestore
      .collection("users/" + userId + "/addresses")
      .doc(addressId);
    writeBatch.delete(addressDoc);

    let promise = primary ? addressDoc.parent
      .get()
      .then(function (snapshot) {
        let docs = snapshot.docs;
        for (let index = 0; index < docs.length; index++) {
          const doc = docs[index];

          if (doc.id !== addressDoc.id) {
            writeBatch.update(doc.ref, { 'primary': true });
          }
        }
      }) : Promise.resolve();

    return promise.then(() => writeBatch.commit());
  });
}

function deletableAddress(userId, addressId) {
  return getSecuredFirestore().then(function (firestore) {
    let userDoc = firestore
      .doc("users/" + userId);
    let addressDoc = firestore
      .doc("users/" + userId + "/addresses/" + addressId);
    let cartsRef = firestore.collection('carts');
    return cartsRef.where('userRef', '==', userDoc).where("addressRef", "==", addressDoc).get().then(function (snapshot) {
      return snapshot.docs.length === 0;
    });
  });
}

function getStaticDeliveryLocationImage(location, options) {
  let width = options && options.width ? options.width : 1024;
  let height = options && options.height ? options.height : 1024;
  return "https://maps.googleapis.com/maps/api/staticmap?center=" +
    location.lat +
    "," +
    location.lng +
    "&markers=color:red%7C" +
    location.lat +
    "," +
    location.lng +
    "&zoom=17&size=" + width + "x" + height + "&key=" +
    process.env.GOOGLE_API_KEY;
}

function sendDeliveryRequest(location) {
  var dialog = f7.dialog.preloader(format("address.dialog.sendingDeliveryRequest") + "...");

  return new Promise(function (resolve, reject) {
    liff
      .sendMessages([
        {
          type: "text",
          text:
            format("address.deliveryRequest.description") + "\n" +
            location
        }
      ])
      .then(function () {
        dialog.close();
        f7.dialog.alert(
          format("address.deliveryRequest.dialog.description"),
          format("address.deliveryRequest.dialog.title"),
          () => {
            resolve();
          }
        );
      })
      .catch(function (e) {
        dialog.close();
        console.log(e);
        f7.dialog.alert(
          format("address.deliveryRequest.dialog.error.description"),
          format("address.deliveryRequest.dialog.title")
        );
        reject();
      });
  });
}

function getDeliverableIcon(deliverable) {
  return deliverable === "yes" ? "icon icon-check" : deliverable === "no" ? "icon icon-warning" : "icon icon-checkoutline";
}

function getDeliverableColor(deliverable) {
  return deliverable === "yes" ? "green" : deliverable === "no" ? "red" : "orange";
}

export { formatAddress, deleteAddress, deletableAddress, setPrimaryAddress, getStaticDeliveryLocationImage, sendDeliveryRequest, getDeliverableIcon, getDeliverableColor, NEW_LINE, COMPACT, HTML }